import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing - sử dụng auth-forms
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/auth-forms/AuthLogin')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/auth-forms/AuthRegister')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/auth-forms/AuthForgotPassword')));
const AuthCheckMail = Loadable(lazy(() => import('views/pages/authentication/auth-forms/AuthCodeVerification')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/identity_verification',
            element: <AuthCheckMail />
        }
    ]
};

export default LoginRoutes;
